export default __webpack_public_path__ + "static/media/add-test-enabled.bc89748c.svg";